export const DigitekaLogoBlack = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 533.7 116.5"
        style={{
            enableBackground: 'new 0 0 533.7 116.5'
        }}
        xmlSpace="preserve"
        {...props}
    >
        <linearGradient
            id="a"
            gradientUnits="userSpaceOnUse"
            x1={278.27}
            y1={1214.681}
            x2={365.661}
            y2={1164.219}
            gradientTransform="translate(-300 -1141)"
        >
            <stop
                offset={0}
                style={{
                    stopColor: '#f80f44'
                }}
            />
            <stop
                offset={0.08}
                style={{
                    stopColor: '#f50f46'
                }}
            />
            <stop
                offset={0.14}
                style={{
                    stopColor: '#ea114a'
                }}
            />
            <stop
                offset={0.21}
                style={{
                    stopColor: '#d81352'
                }}
            />
            <stop
                offset={0.27}
                style={{
                    stopColor: '#bf165d'
                }}
            />
            <stop
                offset={0.33}
                style={{
                    stopColor: '#9f196c'
                }}
            />
            <stop
                offset={0.39}
                style={{
                    stopColor: '#771e7e'
                }}
            />
            <stop
                offset={0.44}
                style={{
                    stopColor: '#482492'
                }}
            />
            <stop
                offset={0.5}
                style={{
                    stopColor: '#132aaa'
                }}
            />
            <stop
                offset={0.5}
                style={{
                    stopColor: '#112aab'
                }}
            />
            <stop
                offset={1}
                style={{
                    stopColor: '#0fd3bd'
                }}
            />
        </linearGradient>
        <path
            d="m17 33.2 41.6 26.1L17 85.4V33.2M3.2 5C1.4 5 0 6.4 0 8.2v102.1c-.1 1.8 1.3 3.2 3.1 3.3h.1c.6 0 1.2-.2 1.7-.5l78.1-49c2.7-1.7 3.4-5.2 1.7-7.9-.4-.7-1-1.3-1.7-1.7L4.9 5.5C4.4 5.2 3.8 5 3.2 5z"
            style={{
                fill: 'url(#a)'
            }}
        />
        <path
            d="M187.2 14.6c-.1-2.3.8-4.6 2.4-6.2 3.7-3.2 9.3-3.2 13 0 3.2 3.5 3.2 9 0 12.5-1.8 1.6-4.1 2.5-6.5 2.4-2.4.1-4.7-.8-6.4-2.4-1.7-1.6-2.6-3.9-2.5-6.3zm17.9 77.2h-16.9V35.9l16.9-7v62.9zm11.2-31.9c0-9.7 2.3-17.5 6.9-23.4 4.5-5.8 10.7-8.8 18.5-8.8s12.3 2.4 16.1 7.1l.7-5.9h15.2v60.8c.1 5-1.1 10-3.7 14.3-2.5 4.1-6.2 7.4-10.6 9.3-5 2.2-10.4 3.3-15.9 3.2-4.6 0-9.2-.9-13.5-2.8-3.9-1.5-7.3-3.9-9.9-7.1l7.4-10.2c3.8 4.5 9.4 7.1 15.3 7 4.4 0 7.9-1.2 10.4-3.5s3.7-5.8 3.7-10.2v-3.4c-3.9 4.4-9.5 6.8-15.3 6.6-7.2.2-14-3.1-18.3-8.8-4.7-6-7-13.8-7-23.6v-.6zm16.8 1.2c0 5.7 1.1 10.2 3.4 13.4 2.1 3.2 5.6 5 9.4 4.9 5.1 0 8.8-1.9 11-5.8V47.1c-2.3-3.8-5.9-5.7-10.9-5.7-3.8-.1-7.4 1.7-9.5 4.9-2.3 3.3-3.4 8.2-3.4 14.8zm53.2-46.5c-.1-2.3.8-4.6 2.4-6.2 3.7-3.2 9.2-3.2 12.9 0 3.2 3.5 3.2 9 0 12.5-1.7 1.6-4 2.5-6.4 2.4-2.4.1-4.7-.8-6.4-2.4-1.7-1.6-2.6-3.9-2.5-6.3zm16.9 77.2h-16.9V35.9l16.9-7v62.9zm32.7-78.4v15.5h10.8v12.3h-10.8v31.4c-.1 1.8.3 3.5 1.3 5 .9 1 2.6 1.5 5.2 1.5 1.6 0 3.3-.2 4.9-.4v12.7c-3.3 1-6.7 1.5-10.2 1.5-11.7 0-17.7-5.9-18-17.8V41.2h-9.2V28.9h9.2v-8.5l16.8-7zm47.9 79.5c-9.3 0-16.8-2.8-22.6-8.5s-8.6-13.2-8.6-22.6v-1.6c-.1-5.8 1.1-11.6 3.6-16.9 2.2-4.8 5.9-8.8 10.4-11.5 4.6-2.8 9.9-4.2 15.3-4.1 8.6 0 15.4 2.7 20.3 8.2s7.4 13.1 7.4 23v6.9h-40c.4 3.8 2.1 7.3 4.9 9.9 2.9 2.5 6.6 3.8 10.4 3.7 6.4 0 11.5-2.4 15.1-7.1l8.3 9.3c-2.6 3.6-6.1 6.5-10.2 8.3-4.5 2-9.4 3.1-14.3 3zm-2-51.6c-3-.1-6 1.1-8.1 3.3-2.3 2.8-3.6 6.1-3.9 9.7h23.3V53c-.1-3.7-1.1-6.6-3-8.7-1.9-2-4.7-3-8.3-3zm59 25.2-6 6.1v19.2H418V9l16.8-6.5v49.4l3.2-4.1 16.1-18.9h20.2l-22.8 26.2 24.7 36.7h-19.3l-16.1-25.3zm76 25.3c-.9-1.8-1.5-3.7-1.7-5.7-4 4.5-9.9 7-15.9 6.8-5.6.2-11-1.7-15.3-5.3-3.9-3.4-6.2-8.3-6.1-13.5 0-6.7 2.5-11.8 7.4-15.4s12.1-5.3 21.5-5.4h7.7v-3.6c.1-2.5-.7-5-2.3-6.9-1.4-1.8-3.8-2.6-7-2.6s-5.1.6-6.7 2-2.5 3.5-2.4 5.6h-16.8c0-3.6 1.2-7.2 3.4-10.1 2.4-3.3 5.7-5.8 9.5-7.3 4.4-1.9 9.1-2.8 13.9-2.7 7.7 0 13.9 2 18.4 5.9s6.8 9.3 6.8 16.4v27.2c.1 6 .9 10.5 2.5 13.6v1h-16.9zm-13.9-11.7c2.4 0 4.7-.6 6.8-1.7 2-1 3.6-2.5 4.7-4.4V63.2h-6.3c-8.4 0-12.9 2.9-13.4 8.7v1c0 1.9.8 3.8 2.2 5.1 1.7 1.4 3.8 2.2 6 2.1zM176 91.3h-16.7l-.9-9.2h-.2c-3.9 7.1-11.2 10.7-19 10.7-14.4 0-25.9-12.7-25.9-32.2-.1-21.1 12.6-33.3 27.1-33.3 7.5 0 13.3 2.7 16 7.1l.8 1.1V8.4L176 0m-19.3 55.2c0-1-.2-2.4-.3-3.4-1.1-5.3-5.2-9.6-11-9.6-8.6 0-13 7.9-13 17.8s5.1 17.3 12.9 17.3c5.4 0 9.8-3.9 10.9-9.4.3-1.5.5-3 .5-4.5v-8.2z"
            style={{
                fill: '#000'
            }}
        />
    </svg>
)
